import { useState } from 'react';

import dynamic from 'next/dynamic';

import { DEFAULT_NPL_FLAG } from '@/app/_constant/srpConstant';
import { cn } from '@/app/_helper/tailwind';

import Chip from './Chip';

const ModalAssetBank = dynamic(() => import('./ModalAssetBank'), {
    ssr: false,
});

const ChipAssetBank = ({ className }: { className?: string }) => {
    const [isShowModal, setShowModal] = useState(false);
    return (
        <>
            <ModalAssetBank
                open={isShowModal}
                onClose={() => setShowModal(false)}
            />
            <button
                data-test-id="badge-aset-bank"
                className='bg-transparent outline-none border-none'
                onClick={(e) => {
                    e.stopPropagation();
                    setShowModal(true);
                }}
            >
                <Chip
                    label={DEFAULT_NPL_FLAG}
                    theme='npl'
                    iconPosition='right'
                    className={cn('cursor-pointer', className)}
                />
            </button>
        </>
    );
};

export default ChipAssetBank;
